<div class="main-wrapper">
    <app-header [publicMode]="true"></app-header>
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
